var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 9,
    fill: "#EFF1F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5679 17.1176L23.0078 18.5655C23.3775 18.9414 23.4863 19.5022 23.2838 19.9891C23.0814 20.476 22.6071 20.7944 22.0798 20.7974H19.392V21.0693C19.3142 22.7602 17.8833 24.0695 16.1922 23.9971C14.5011 24.0695 13.0702 22.7602 12.9924 21.0693V20.7974H10.3046C9.77729 20.7944 9.30301 20.476 9.10057 19.9891C8.89813 19.5022 9.00688 18.9414 9.37665 18.5655L10.8166 17.1176V13.3818C10.8194 11.8309 11.49 10.3562 12.657 9.33471C13.824 8.31318 15.3745 7.84368 16.9122 8.04619C19.6204 8.46127 21.6075 10.8103 21.5679 13.5498V17.1176ZM16.1922 22.3973C16.9949 22.4539 17.6999 21.8687 17.7921 21.0693V20.7974H14.5923V21.0693C14.6845 21.8687 15.3895 22.4539 16.1922 22.3973Z",
    fill: "#92929C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.5858d9cd.svg";
export { ForwardRef as ReactComponent };